import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.objetos;

// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'objetos',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});

// Function to fetch all objects
export const getAllObjetos = async () => {
  return await retryWithBackoff(() =>
    cachedApi.get('/GetAllObjetos')
  );
};

// Function to fetch objects by company ID
export const getObjetosByCompanyId = async (companyId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetObjetosByCompanyId/${companyId}`)
  );
};

// Function to fetch objects by local ID
export const getObjetosByLocalId = async (localId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetObjetosByLocalId/${localId}`)
  );
};

// Function to fetch objects by salon ID
export const getObjetosBySalonId = async (salonId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetObjetosBySalonId/${salonId}`)
  );
};

// Function to fetch a single object by ID
export const getObjetoById = async (objetoId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetObjetoById/${objetoId}`)
  );
};

// Function to create an object
export const createObjeto = async (objetoData: any) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateObjeto', objetoData)
  );
  await cachedApi.clear();
  return res;
};

// Function to update an object
export const updateObjeto = async (objetoId: number, objetoData: any) => {
  const res = await retryWithBackoff(() =>
    api.put(`/UpdateObjeto/${objetoId}`, objetoData)
  );
  await cachedApi.clear();
  return res;
};

// Function to delete an object
export const deleteObjeto = async (objetoId: number) => {
  const res = await retryWithBackoff(() =>
    api.delete(`/DeleteObjeto/${objetoId}`)
  );
  await cachedApi.clear();
  return res;
};
